<script setup lang="ts" async>
import {Packages, PackageItem, PackageItemImage, PackageItemContent, PackageItemFooter} from '@/lib/ui/packages';

useMenuState().value = 'collapsed';

const showStayInTheLoop = ref(false);
</script>

<template>
  <NuxtLayout name="text-only" class="blurred-bground">
    <div class="flex flex-col !gap-[6rem]">
      <section class="w-full flex flex-col pt-[5rem] leading-30 gap-[6rem]">
        <h1 class="text-white">
          One Times Square
          <br />
          Experiences
        </h1>
      </section>

      <section class="flex flex-col gap-16">
        <div class="flex flex-col gap-6">
          <h2 class="text-white">iCandy Experience</h2>
          <p class="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
        </div>

        <Packages class="!justify-start">
          <PackageItem>
            <PackageItemImage>
              <img :src="`${useCdnUrl()}/assets/buy-tickets/icandy-tickets-header.png`" alt="Times Travel VIP Package 1" class="w-full h-auto" />
            </PackageItemImage>
            <PackageItemTitle class="!bg-[var(--icandy-color)]">
              <template #title>
                iCandy
                <br />
                Experience
              </template>
            </PackageItemTitle>
            <PackageItemContent>
              <p>A four-floor, New York City-themed immersive candy experience. Guests buy a ticket and receive a container to fill with candy as they move through the experience.</p>
            </PackageItemContent>

            <PackageItemFooter>
              <TheButton tag="NuxtLink" class="w-full !border-none !py-4 w-[270px] hover:!bg-black hover:!text-white !bg-[var(--icandy-color)]" to="https://www.icandynyc.com/" target="_blank">Buy Tickets</TheButton>
            </PackageItemFooter>
          </PackageItem>
        </Packages>
      </section>

      <Divider class="!border-white" />

      <section class="flex flex-col gap-16">
        <div class="flex flex-col gap-6">
          <h2 class="text-white">VIP Ball and Crystal VIP Experience</h2>
          <p class="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <div class="w-[300px]">
            <TheButton tag="NuxtLink" class="w-full !border-none !py-4 w-[270px] hover:!bg-black hover:!text-white !bg-[var(--crystal-vip-color-darker)]" to="/nye-ball-crystal-vip-experience">Learn More</TheButton>
          </div>
        </div>

        <Packages class="!justify-start">
          <PackageItem>
            <PackageItemImage>
              <img :src="`${useCdnUrl()}/assets/buy-tickets/tt-vip-ticket-header.png`" alt="Times Travel VIP Package 1" class="w-full h-auto" />
            </PackageItemImage>
            <PackageItemTitle class="!bg-[var(--crystal-vip-color-darker)]">
              <template #title>VIP</template>
              <template #subtitle>Starting at $XX</template>
            </PackageItemTitle>
            <PackageItemContent>
              <ul class="list-disc list-inside">
                <li>Viewing Deck access</li>
                <li>See the all-new New Year's Eve Ball</li>
                <li>Photo op with the Ball</li>
                <li>Guided tour of history of the Ball</li>
              </ul>
            </PackageItemContent>

            <PackageItemFooter>
              <TheButton tag="NuxtLink" class="w-full !border-none !py-4 w-[270px] hover:!bg-black hover:!text-white !bg-[var(--crystal-vip-color-darker)]" to="/nye-ball-crystal-vip-experience#buy-tickets">Buy Tickets</TheButton>
            </PackageItemFooter>
          </PackageItem>

          <PackageItem>
            <PackageItemImage>
              <img :src="`${useCdnUrl()}/assets/crystal-vip/tt-vip-package-1.png`" alt="Times Travel VIP Package 1" class="w-full h-auto" />
            </PackageItemImage>
            <PackageItemTitle class="!bg-[var(--crystal-vip-color-darker)]">
              <template #title>Crystal VIP</template>
              <template #subtitle>Starting at $XX</template>
            </PackageItemTitle>
            <PackageItemContent>
              <ul class="list-disc list-inside">
                <li>Viewing Deck access</li>
                <li>See the all-new New Year's Eve Ball</li>
                <li>Photo op with the Ball</li>
                <li>Guided tour of history of the Ball</li>
                <li>Place a crystal on the Ball, and customize it with a Morse code message that will display on New year's Eve</li>
                <li>Take home one of this year's keepsake crystals</li>
              </ul>
            </PackageItemContent>

            <PackageItemFooter>
              <TheButton tag="NuxtLink" class="w-full !border-none !py-4 w-[270px] hover:!bg-black hover:!text-white !bg-[var(--crystal-vip-color-darker)]" to="/nye-ball-crystal-vip-experience#buy-tickets">Buy Tickets</TheButton>
            </PackageItemFooter>
          </PackageItem>
        </Packages>
      </section>

      <Divider class="!border-white" />

      <section class="flex flex-col gap-16">
        <div class="flex flex-col gap-6">
          <h2 class="text-white">Times Travel + Viewing Deck</h2>
          <p class="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
        </div>

        <Packages class="!justify-start">
          <PackageItem>
            <PackageItemImage>
              <img :src="`${useCdnUrl()}/assets/buy-tickets/tt-ticket-header.png`" alt="Times Travel VIP Package 1" class="w-full h-auto" />
            </PackageItemImage>
            <PackageItemTitle class="!bg-[var(--times-travel-color)]">
              <template #title>Coming Soon</template>
              <!-- <template #subtitle>Starting at $XX</template> -->
            </PackageItemTitle>
            <PackageItemContent>
              <p>Join the waitlist and be the first to know when tickets sales open.</p>
            </PackageItemContent>

            <PackageItemFooter>
              <TheButton tag="NuxtLink" class="w-full !border-none !py-4 hover:!bg-black hover:!text-white !bg-[var(--times-travel-color)]" aria-label="Join the waitlist" @click="showStayInTheLoop = true">Join the waitlist</TheButton>
            </PackageItemFooter>
          </PackageItem>
        </Packages>

        <Teleport to="body">
          <TheModal v-if="showStayInTheLoop" @close-modal="showStayInTheLoop = false">
            <template #content>
              <FormsSignUp @close-modal="showStayInTheLoop = false" />
            </template>
          </TheModal>
        </Teleport>
      </section>

      <Divider class="!border-white" />

      <section class="flex flex-col gap-16">
        <div class="flex flex-col gap-6">
          <h2 class="text-white">Ever</h2>
          <p class="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
        </div>

        <Packages class="!justify-start">
          <PackageItem>
            <PackageItemImage>
              <img :src="`${useCdnUrl()}/assets/buy-tickets/ever-ticket-header.png`" alt="Times Travel VIP Package 1" class="w-full h-auto" />
            </PackageItemImage>
            <PackageItemTitle class="!bg-[var(--ever-color)]">
              <template #title>Coming Soon</template>
              <!-- <template #subtitle>Starting at $XX</template> -->
            </PackageItemTitle>
            <PackageItemContent>
              <p>Be the first to celebrate your love at the iconic One Times Square.</p>
            </PackageItemContent>

            <PackageItemFooter>
              <TheButton tag="NuxtLink" class="w-full !border-none !py-4 w-[270px] hover:!bg-black hover:!text-white !bg-[var(--ever-color)]" to="/ever">Reserve your date</TheButton>
            </PackageItemFooter>
          </PackageItem>
        </Packages>
      </section>
    </div>
  </NuxtLayout>
</template>

<style lang="scss">
//!bg-black bg-[url('/assets/ots-building-bground.jpg')] bg-no-repeat bg-size-[100%_auto] bg-top bg-fixed
.blurred-bground {
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  background:
    linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url('/assets/ots-building-bground.jpg') no-repeat;
  background-attachment: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  background-position: top;
  background-size: 100vw 100vh;

  background-size: cover;
  p {
    max-width: 1100px;
  }
}
</style>
